export default __webpack_public_path__ + "static/media/icn-mail.efbb57cc.svg";